import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import QRCode from "react-qr-code";

const AppQRcode = () => {
  const [t] = useTranslation();

  return (
    <Box
      sx={{ padding: "20px 10px", display: "flex", justifyContent: "center" }}
    >
      <Box sx={{ maxWidth: "440px" }}>
        <Typography
          variant="h3"
          sx={{ padding: "10px", border: "1px solid #000" }}
        >
          {t("app_name")}
        </Typography>
        <Box sx={{ padding: "10px", border: "1px solid #000" }}>
          <QRCode
            value="https://shikritigroup.com/"
            size={300}
            viewBox={`0 0 300 300`}
            title="Shikriti"
            level="H"
          />
        </Box>
        <Typography
          variant="subtitle2"
          sx={{ padding: "10px", border: "1px solid #000" }}
        >
          {t("qrcode.subtilte")}
        </Typography>
      </Box>
    </Box>
  );
};

export default AppQRcode;
